import ApiClient from './ApiClient';

class MaintenanceNoticeAPI extends ApiClient {
  constructor() {
    super('maintenance_notice', { apiVersion: 'v1' });
  }
}

export default new MaintenanceNoticeAPI();
